export enum UserRole {
  SUPER_ADMIN = 'SuperAdmin',
  ADMIN = 'Admin',
  DOCTOR = 'Doctor',
  PATIENT = 'Patient',
  HEALTH_VISITOR = 'HealthVisitor',
  DATA_MANAGER = 'DataManager',
  CRO = 'CRO'
}
